import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const ALERT_SHARE_EVENT_NAMES = {
  ALERT_SHARE_SUBMIT: 'user_shares_alert_to_first_responders',
};

export const trackAlertShareSubmit = (
  numEmailRecipients,
  numSMSRecipients,
  irpVersion,
) => {
  gspx.trackEvent({
    name: ALERT_SHARE_EVENT_NAMES.ALERT_SHARE_SUBMIT,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Alert',
      legacy_name: 'User shares alert to first responders',
      Category: 'Alert',
      'Launched date': new Date(),
      irpVersion,
      numEmailRecipients,
      numSMSRecipients,
    },
  });
};
